// extracted by mini-css-extract-plugin
export default {"container":"Gate_container__JNl9f","childrenContainer":"Gate_childrenContainer__OIRE3"};